import React, { useContext, useState, useEffect } from 'react'

import Navbar from 'react-bootstrap/Navbar';

import {
    BrowserRouter as Router,
    Route,
    Routes,
} from "react-router-dom";

import { UiContext } from '../context/UiContext';

import { SideMenu } from '../components/sideMenu';
import { Salir } from '../components/salir';
import { UsuarioPassword } from '../components/usuarioPassword';
import { GuardiaSesion } from '../components/GuardiaSesion';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage';
import { setFavicon } from '../helpers/setFavicon';
import { aplicarTemaDesdeStorage } from '../helpers/theme';
import { serverApi } from '../api';

import { Cola } from './Cola';
import { Cola2 } from './Cola2';
import { CrearTicket } from './CrearTicket';
import { CrearTicketV2 } from './CrearTicketV2';
import { Modulo } from './ModuloAtencion/Modulo';
import { Informes } from './Informes/Informes';
import { NuevoDashboard } from './Informes/NuevoDashboard';
import { ListaPacientes } from './Informes/Lista-Pacientes';
import { Ingreso } from './Ingreso';
import { EnBlanco } from './EnBlanco';
import { ModuloConsultorio } from './ModuloConsultorio/ModuloConsultorio';
import { UsuariosPage } from './Usuarios/UsuariosPage';
import { ModulosTipoAtencionPage } from './Modulos/Modulos-TiposAtencion';
import { ModulosCreacion } from './Modulos/Modulos-Creacion';
import { TiposAtencionPage } from './TiposAtencion/TiposAtencionPage';
import { VideosAdmin } from './Videos-Admin/Videos-Admin';
import { UbicacionesCreacion } from './Ubicaciones/Ubicaciones-Creacion';
import { SuperAdminLogin } from './SuperAdmin/SuperAdminLogin';
import { SuperAdminPanel } from './SuperAdmin/SuperAdminPanel';
import { VendedorPanel } from './SuperAdmin/VendedorPanel';
import { CallScreen } from './CallScreen';
import { CallScreenV2 } from './CallScreenV2';
import { MiEmpresaPage } from './MiEmpresaPage';

export const RouterPage = () => {

    const { ocultarMenu } = useContext(UiContext);

    const [collapsed, setCollapsed] = useState(false);
    const [toggled, setToggled] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const [showPassword, setShowPassword] = useState(false);

    // ── Cerrar sesión cuando el token falta o expira ──────────────────────
    useEffect(() => {
        const cerrarSesion = () => {
            // Limpiar datos de usuario (conservar datos del kiosko)
            localStorage.removeItem('token');
            localStorage.removeItem('uidUsuario');
            localStorage.removeItem('usuario');
            localStorage.removeItem('agente');
            localStorage.removeItem('modulo');
            localStorage.removeItem('uidModulo');
            localStorage.removeItem('pantallas');
            localStorage.removeItem('nombreEntidad');
            localStorage.removeItem('imagenLogo');
            localStorage.removeItem('imagenIcono');
            localStorage.removeItem('colorPrimario');
            localStorage.removeItem('colorSecundario');
            // Redirigir al login
            window.location.href = '/';
        };

        window.addEventListener('sesion-expirada', cerrarSesion);
        return () => window.removeEventListener('sesion-expirada', cerrarSesion);
    }, []);

    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);

            if (window.innerWidth >= 768) {
                setToggled(false);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);

    }, []);

    // Establecer favicon y tema de la empresa al cargar/reload
    useEffect(() => {
        const usuario = getUsuarioStorage();
        setFavicon(usuario.imagenIcono || usuario.imagenLogo);
        aplicarTemaDesdeStorage();
    }, []);

    return (

        <Router>

            <GuardiaSesion />

            <div className="app-layout">


                {
                    !ocultarMenu &&
                    (
                        <SideMenu
                            collapsed={collapsed}
                            toggled={toggled}
                            setToggled={setToggled}
                        />
                    )
                }

                <main
                    className={`main-content ${collapsed ? 'collapsed-content' : ''}`}>

                    {
                        !ocultarMenu &&
                        (() => {
                            const usuarioStorage = getUsuarioStorage();

                            // Resuelve la URL absoluta de un recurso (logo/ícono) de la entidad
                            const urlRecurso = (path) => {
                                if (!path) return null;
                                return path.startsWith('http')
                                    ? path
                                    : `${serverApi.defaults.baseURL.replace('/api', '')}${path}`;
                            };

                            const logoCompletoUrl = urlRecurso(usuarioStorage.imagenLogo);
                            const iconoUrl = urlRecurso(usuarioStorage.imagenIcono);

                            // En pantallas pequeñas mostramos el ícono; en pantallas
                            // normales/grandes, el logo completo. Si falta uno, se usa el otro.
                            const navbarLogoUrl = isMobile
                                ? (iconoUrl || logoCompletoUrl)
                                : (logoCompletoUrl || iconoUrl);

                            return (
                                <>
                                    <Navbar className="top-navbar px-3 d-flex justify-content-between align-items-center">

                                        <div className="d-flex align-items-center gap-3 navbar-marca">

                                            <button
                                                className="menu-btn"
                                                onClick={() => {
                                                    if (isMobile) {
                                                        setToggled(!toggled);
                                                    } else {
                                                        setCollapsed(!collapsed);
                                                    }
                                                }}
                                            >
                                                <i className="fa-solid fa-bars"></i>
                                            </button>

                                            {/* Branding de Empresa en Navbar Principal */}
                                            {(navbarLogoUrl || usuarioStorage.nombreEntidad) && (
                                                <div className="navbar-marca-inner ms-2 ps-2 border-start border-2">
                                                    {navbarLogoUrl && (
                                                        <img
                                                            key={navbarLogoUrl}
                                                            className="navbar-marca-logo"
                                                            src={navbarLogoUrl}
                                                            alt={isMobile ? "Ícono Empresa" : "Logo Empresa"}
                                                            onError={(e) => { e.target.style.display = 'none'; }}
                                                        />
                                                    )}
                                                    {usuarioStorage.nombreEntidad && (
                                                        <div className="navbar-marca-texto">
                                                            <span
                                                                className="navbar-marca-nombre"
                                                                title={usuarioStorage.nombreEntidad}
                                                            >
                                                                {usuarioStorage.nombreEntidad}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                        </div>

                                        <div className="d-flex align-items-center gap-2 navbar-sesion">

                                            {/* Sesión del agente: estática en el navbar */}
                                            <div
                                                title="Cambiar contraseña"
                                                onClick={() => setShowPassword(true)}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 10,
                                                    padding: '5px 12px 5px 6px',
                                                    borderRadius: 12,
                                                    cursor: 'pointer',
                                                    background: 'var(--color-primario-suave)',
                                                    border: '1px solid var(--color-primario-borde)',
                                                    transition: 'background .2s ease, transform .2s ease',
                                                    maxWidth: '100%',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = 'var(--color-secundario-suave)';
                                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = 'var(--color-primario-suave)';
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: 34,
                                                        height: 34,
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontWeight: 700,
                                                        fontSize: 15,
                                                        color: 'var(--color-marca-contraste)',
                                                        flexShrink: 0,
                                                        background: 'var(--gradiente-marca)',
                                                    }}
                                                >
                                                    {usuarioStorage.agente ? usuarioStorage.agente.charAt(0).toUpperCase() : 'U'}
                                                </div>

                                                <div className="navbar-sesion-detalle" style={{ lineHeight: 1.2, minWidth: 0 }}>
                                                    <div style={{ fontWeight: 600, color: 'var(--color-primario-texto)', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 160 }}>
                                                        {usuarioStorage.agente}
                                                    </div>
                                                    {usuarioStorage.usuario && (
                                                        <small style={{ color: 'var(--color-secundario-oscuro)', fontSize: 11 }}>
                                                            @{usuarioStorage.usuario}
                                                        </small>
                                                    )}
                                                </div>
                                            </div>

                                            <Salir />
                                        </div>

                                    </Navbar>

                                    <UsuarioPassword
                                        show={showPassword}
                                        onClose={() => setShowPassword(false)}
                                    />
                                </>
                            );
                        })()
                    }

                    <div className="page-container">

                        <Routes>
                            <Route path='/cola' element={<Cola />} />
                            <Route path='/cola2' element={<Cola2 />} />
                            <Route path='/callscreen' element={<CallScreen />} />
                            <Route path='/callscreen-v2' element={<CallScreenV2 />} />
                            <Route path='/pantalla' element={<CallScreenV2 />} />
                            <Route path='/crear' element={<CrearTicket />} />
                            <Route path='/crear2' element={<CrearTicketV2 />} />
                            <Route path='/modulo' element={<Modulo />} />
                            <Route path='/informes' element={<Informes />} />
                            <Route path='/nuevo-dashboard' element={<NuevoDashboard />} />
                            <Route path='/lista-Pacientes' element={<ListaPacientes />} />
                            <Route path='/inicio' element={<EnBlanco />} />
                            <Route path='/*' element={<Ingreso />} />

                            <Route path='/consultorio' element={<ModuloConsultorio />} />
                            <Route path='/tiposAtencion' element={<TiposAtencionPage />} />
                            <Route path='/ubicaciones' element={<UbicacionesCreacion />} />

                            <Route path='/modulos-creacion' element={<ModulosCreacion />} />
                            <Route path='/modulos-tiposAtencion' element={<ModulosTipoAtencionPage />} />
                            <Route path='/videos-admin' element={<VideosAdmin />} />
                            <Route path='/usuarios' element={<UsuariosPage />} />
                            <Route path='/mi-empresa' element={<MiEmpresaPage />} />

                            {/* Rutas SuperAdmin y Vendedores */}
                            <Route path='/superadmin' element={<SuperAdminLogin />} />
                            <Route path='/superadmin/dashboard' element={<SuperAdminPanel />} />
                            <Route path='/vendedor/dashboard' element={<VendedorPanel />} />

                        </Routes>

                    </div>

                </main>

            </div>

        </Router>
    )
}